
<section
  :data-component-name="$options.name"
  :data-page="jel_getNomRouteCourante()"
  class="section-sansTheme section-page gs_section row no-gutters image-fond"
  :class="classObject"
  :style="[getStyleObject()]"
>
  <div class="contenu mx-auto" :class="[content.cssClassContenu]">
    <Heading
      v-if="!hideTitleIfMobile(content.afficherTitreMobile)"
      :class="[
        content.titleCSS ? content.titleCSS : 'gs_titre graphik_bold mb-4',
        content.titleOverBackground === 'true' ? 'gs_titre_top_neg' : '',
      ]"
      :contentType="content.typeTitle || 'grandTitre'"
      :style="{ color: content.titleColor }"
      v-html="content.title"
    />
    <p v-if="content.title2" class="gs_sous_titre">
      {{ content.title2 }}
    </p>

    <EditableArea
      :content="content.grandeSection"
      :parentTemplateId="metadata['mgnl:template']"
    />
  </div>
</section>
